/* eslint-disable @typescript-eslint/no-explicit-any */
// import { API_URL_WS } from "@constants";
// import SockJS from "sockjs-client";
import Stomp from "stompjs";

class WebSocketService {
  stompClient: null | Stomp.Client = null;
  connected = false;
  isConnecting = false;
  topicCallbacks: Record<string, (arg: any) => void> = {};
  topicIds: Record<string, string> = {};

  connect(onConnected?: () => void) {
    if (this.connected || this.isConnecting) return;

    this.isConnecting = true;
    // const socket = new SockJS(API_URL_WS);
    // this.stompClient = Stomp.over(socket);
    // this.stompClient.debug = () => {};
    // this.stompClient.connect(
    //   {},
    //   () => {
    //     this.onConnected();
    onConnected?.();
    //   },
    //   this.reconnect
    // );
  }

  reconnect = () => {
    console.log("Reconnecting to WebSocket...");
    this.isConnecting = false;
    setTimeout(() => this.connect(), 5000);
  };

  onConnected = () => {
    console.log("Connected to WebSocket server");
    this.connected = true;
    this.isConnecting = false;
  };

  onError = (error: any) => {
    console.error("WebSocket connection error: ", error);
  };

  subscribeToTopic(
    topic: string,
    topicKey: string,
    callback: (arg: any) => void
  ) {
    if (this.stompClient?.connected) {
      const subscribe = this.stompClient?.subscribe(topic, (message) => {
        callback(message.body);
      });

      this.topicIds[topicKey] = subscribe.id;
    }
  }

  sendMessage = (destination: string, message: any) => {
    if (this.stompClient?.connected) {
      this.stompClient.send(destination, {}, JSON.stringify(message));
    }
  };

  unsubscribe = (topicKey: string) => {
    if (this.stompClient?.connected) {
      this.stompClient.unsubscribe(this.topicIds[topicKey]);
    }
  };

  disconnect = (onDisconnected?: () => void) => {
    if (this.stompClient?.connected) {
      this.stompClient.disconnect(() => {
        this.onDisconnected();
        onDisconnected?.();
      });
    }
  };

  onDisconnected = () => {
    console.log("Disconnected from WebSocket server");
    this.connected = false;
  };
}

const websocketService = new WebSocketService();
export default websocketService;
